'use strict';

var unified = require('unified');
var parse = require('remark-parse');
var stringify = require('remark-stringify');

module.exports = unified().use(parse).use(stringify).freeze();



//////////////////
// WEBPACK FOOTER
// ./~/remark/index.js
// module id = 236
// module chunks = 96961042003272 139266963665775